/**
 * @generated SignedSource<<d11dd535ed99cc44f5fc1c6c3d19a8b7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EntityHistoryEntry_entry$data = {
  readonly createdAt: string | null;
  readonly description: string | null;
  readonly name: string;
  readonly user: {
    readonly name: string;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"EntityHistoryEntryIcon_entry" | "EntityHistoryJsonContext_entry">;
  readonly " $fragmentType": "EntityHistoryEntry_entry";
};
export type EntityHistoryEntry_entry$key = {
  readonly " $data"?: EntityHistoryEntry_entry$data;
  readonly " $fragmentSpreads": FragmentRefs<"EntityHistoryEntry_entry">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EntityHistoryEntry_entry",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EntityHistoryJsonContext_entry"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EntityHistoryEntryIcon_entry"
    }
  ],
  "type": "LogEntry",
  "abstractKey": null
};
})();

(node as any).hash = "982a1987fcd562eba9ee8557450eb7ee";

export default node;
